// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_se-0";
export var checkoutRateBadgeLink = "_se-1";